import { useState } from 'react';
import Router from 'next/router';
import Container from '@/ui/container';
import Layout from '@/features/layout/index';

// Form Sections
import SeniorInfo from '@/features/form-group/senior-applicant';
import GiftSection from '@/features/form-group/senior-gift';
import Income from '@/features/form-group/income';
import Terms from '@/features/form-group/terms';
import ErrorDialog from '@/features/modal/error';
import { getSiteSettings } from 'modules/site-settings';

const defaultIncomeVerificationValues = {
	income: '',
	source: '',
	document: ''
};

const defaultGiftValues = {
	gift: '',
	shirt: '',
	pant: '',
	shoe: '',
	deliveryLocation: '',
	specialRequest: ''
};

const initalApplicantValues = {
	firstName: '',
	lastName: '',
	email: '',
	phoneNumber: '',
	dob: '',
	addressLine1: '',
	ssn: '',
	city: '',
	state: '',
	zipCode: '',
	gender: '',
	lifeEvents: ''
};

export default function AppForm({}) {
	// Form State
	const [isLoading, setIsLoading] = useState(false);

	// Handle Errors
	const [submitErrors, setSubmitErrors] = useState(undefined);
	const [isOpen, setIsOpen] = useState(false);

	const [applicantInfo, setApplicantInfo] = useState(initalApplicantValues);
	const [incomeVerifications, setIncomeVerifications] = useState([
		defaultIncomeVerificationValues
	]);

	const [gifts, setGifts] = useState(defaultGiftValues);

	const [terms, setTerms] = useState({
		eraAllowed: false,
		acceptTerms: false
	});

	async function submitForm(e) {
		e.preventDefault();
		setIsLoading(true);

		const response = await fetch('/api/application/senior', {
			method: 'POST',
			body: JSON.stringify({
				applicantInfo,
				incomeVerifications,
				requestedGifts: gifts,
				terms
			}),
			headers: {
				'Content-Type': 'application/json'
			}
		});

		const res = await response.json();

		if (response.status === 201) {
			Router.push({
				pathname: `/success/senior/${res.data}`
			});
		} else {
			setSubmitErrors(res.message || 'Problem Creating Application');
			setIsOpen(true);
			console.error('Error Submitting Applicaion on Senior App Page');
		}
	}

	return (
		<Layout data-sentry-element="Layout" data-sentry-component="AppForm" data-sentry-source-file="index.jsx">
			<main className=" flex flex-col mx-4">
				<h1 className="text-3xl text-center mt-4">
					New Senior Application
				</h1>
				<ErrorDialog
					isOpen={isOpen}
					setIsOpen={setIsOpen}
					setIsLoading={setIsLoading}
					error={submitErrors}
				data-sentry-element="ErrorDialog" data-sentry-source-file="index.jsx" />
				{/* Senior */}
				<section className="mt-6">
					<Container data-sentry-element="Container" data-sentry-source-file="index.jsx">
						<div className="mt-4 sm:mt-0">
							<div className="md:grid md:grid-cols-2 md:px-12 lg:px-32">
								<div className="mt-5 md:mt-0 md:col-span-2 ">
									<form onSubmit={(e) => submitForm(e)}>
										<div className="shadow-sm overflow-hidden sm:rounded-md border border-gray-300">
											<div className="px-4 py-5 sm:p-6">
												<SeniorInfo
													applicantInfo={
														applicantInfo
													}
													setApplicantInfo={
														setApplicantInfo
													}
												data-sentry-element="SeniorInfo" data-sentry-source-file="index.jsx" />
												<Income
													applicationType="senior"
													incomeVerifications={
														incomeVerifications
													}
													setIncomeVerifications={
														setIncomeVerifications
													}
													defaultValues={
														defaultIncomeVerificationValues
													}
													description="A copy of a Paystub, SSI, Compass or other similar document
					are valid forms of income verfication. "
												data-sentry-element="Income" data-sentry-source-file="index.jsx" />
											</div>
											<GiftSection
												gifts={gifts}
												setGifts={setGifts}
											data-sentry-element="GiftSection" data-sentry-source-file="index.jsx" />
											<Terms
												terms={terms}
												setTerms={setTerms}
											data-sentry-element="Terms" data-sentry-source-file="index.jsx" />
										</div>
										<div className="px-4 py-3 mt-10  text-right sm:px-6 flex justify-center pb-10">
											{isLoading ? (
												<button
													type="button"
													className="bg-gray-500 rounded-md p-2 mt-2 text-white w-1/2 justify-center py-2 px-4 shadow-xs flex"
												>
													<svg
														className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
														xmlns="http://www.w3.org/2000/svg"
														fill="none"
														viewBox="0 0 24 24"
													>
														<circle
															className="opacity-25"
															cx="12"
															cy="12"
															r="10"
															stroke="currentColor"
															strokeWidth="4"
														></circle>
														<path
															className="opacity-75"
															fill="currentColor"
															d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
														></path>
													</svg>{' '}
													<span className="text-sm font-medium ">
														Submitting
													</span>
												</button>
											) : (
												<button
													type="submit"
													className="bg-emerald-500 transform hover:scale-105 transition-transform duration-200 rounded-md p-2 mt-2 text-white w-1/2  py-2 px-4 border border-transparent shadow-xs text-sm font-medium"
												>
													Submit Application
												</button>
											)}
										</div>
									</form>
								</div>
							</div>
						</div>
					</Container>
				</section>
			</main>
		</Layout>
	);
}

export async function getServerSideProps() {
	const { applicationsOpen } = await getSiteSettings();
	if (!applicationsOpen) {
		return { redirect: { destination: '/', permanent: false } };
	}
	return { props: {} };
}
